export default __webpack_public_path__ + "static/media/dogAndMan@2x.26683458.png";